// extracted by mini-css-extract-plugin
export default {"footer":"LoraFooter_footer__ix1at","footerLink":"LoraFooter_footerLink__nvdZJ"};